@if (!isDismissed()) {
  <div class="sunset-overlay">
    <div class="sunset-modal">
      <div class="sunset-modal-icon">
        <lucide-icon [img]="AlertTriangle" [size]="36" />
      </div>
      <h2 class="sunset-modal-title">This environment is sunsetting soon</h2>
      <ul class="sunset-modal-list">
        <li>
          Tasks created
          <strong>after April 13, 2026</strong>
          &mdash; complete them on the new site.
        </li>
        <li>
          Tasks created
          <strong>before April 14, 2026</strong>
          &mdash; complete them here in this environment.
        </li>
      </ul>
      <p class="sunset-modal-help">
        For issues, contact your local site admin or submit an SLHS ticket for assistance.
      </p>
      <div class="sunset-modal-actions">
        <a
          class="sunset-modal-btn sunset-modal-btn--primary"
          href="https://slhs.xqworkflow.com/"
          target="_blank"
        >
          Take me to the new site
        </a>
        <button class="sunset-modal-btn sunset-modal-btn--ghost" (click)="dismissBanner()">
          Continue to old environment
        </button>
      </div>
    </div>
  </div>
}
